/* eslint-disable import/order */

import AssetsLinks from "./assets-links.json";

import EcoFriendly from "./eco-friendly.png";
import RatingImg from "./rating-white.png";
import RatingBlackImg from './rating-black.png';
import Awareness from "./brand-awareness-white.png";
import PosImg from "./pos-rating-white.png";
import MarketImg from "./market-white.png";
import EcomImg from "./eco-rating-white.png";

import NonEcoFriendly from "./non-eco-friendly.png";
import SizeBig from "./size-big.png";
import SizeStandard from "./size-standard.png";
const {
  YoungImgWhite,
  YoungImg2Black,
  YoungImg2White,
  YoungImgBlack,
  YoungImgBothBlack,
  YoungImgBothWhite,
  Accessories1ImgBlack,
  Accessories2ImgBlack,
  Accessories1ImgWhite,
  Accessories2ImgWhite,
  MenImgBlack,
  MenImgWhite,
  KidImgBlack,
  KidImgWhite,
  KidsImgBlack,
  KidsImgWhite,
  WomenImgBlack,
  WomenImgWhite,
  MiddleImg2Black,
  MiddleImg2White,
  MiddleImgBlack,
  MiddleImgBothBlack,
  MiddleImgBothWhite,
  MiddleImgWhite,
  TeenImg2Black,
  TeenImg2White,
  TeenImgBlack,
  TeenImgBothBlack,
  TeenImgBothWhite,
  TeenImgWhite,
  ToddlerImgBlack,
  ToddlerImgWhite,
  SeniorImgBlack,
  SeniorImgBothBlack,
  SeniorImgBothWhite,
  SeniorImgWhite,
  Occasion1ImgBlack,
  Occasion1ImgWhite,
  OuterWear1ImgBlack,
  OuterWear1ImgWhite,
  AllAgesBlack,
  AllAgesWhite,
  Apparel2ImgBlack,
  Apparel2ImgWhite,
  Athleisure1ImgBlack,
  Athleisure1ImgWhite,
  Athleisure2ImgBlack,
  Athleisure2ImgWhite,
  Athleisure3ImgBlack,
  Athleisure3ImgWhite,
  BabyImgBlack,
  BabyImgWhite,
  Bags1ImgBlack,
  Bags1ImgWhite,
  Bohemian1ImgBlack,
  Bohemian1ImgWhite,
  Bohemian2ImgBlack,
  Bohemian2ImgWhite,
  Bohemian3ImgBlack,
  Bohemian3ImgWhite,
  Casual1ImgBlack,
  Casual1ImgWhite,
  Casual2ImgBlack,
  Casual2ImgWhite,
  Casual3ImgBlack,
  Casual3ImgWhite,
  Classic1ImgBlack,
  Classic1ImgWhite,
  Classic2ImgBlack,
  Classic2ImgWhite,
  Classic3ImgBlack,
  Classic3ImgWhite,
  Contemporary1ImgBlack,
  Contemporary1ImgWhite,
  Contemporary2ImgBlack,
  Contemporary2ImgWhite,
  Contemporary3ImgBlack,
  Contemporary3ImgWhite,
  DistributorBlackImg,
  DistributorImg,
  FootWear2ImgBlack,
  FootWear2ImgWhite,
  Glases1ImgBlack,
  Glases1ImgWhite,
  Lingerie1ImgBlack,
  Lingerie1ImgWhite,
  Jewelry1ImgBlack,
  Jewelry1ImgWhite,
  PriceBlackImg,
  PriceImg,
  Socks1ImgBlack,
  Socks1ImgWhite,
  Sport1ImgBlack,
  Sport1ImgWhite,
  Sport2ImgBlack,
  Sport2ImgWhite,
  Sport3ImgBlack,
  Sport3ImgWhite,
  Swimwear1ImgBlack,
  Swimwear1ImgWhite,
} = AssetsLinks;

// BRAND PROFILE TABS DATA
export const appendable_columns = [
  { id: "name", label: "Name", required: true },
  { id: "website", label: "Website", required: true },
  { id: "market", label: "Location" },
  { id: "email", label: "Email" },
  { id: "phone", label: "Phone" },
  { id: "linkedin", label: "LinkedIn" },
  { id: "instagram", label: "Instagram" },
  { id: "facebook", label: "Facebook" },
  { id: "street", label: "Street" },
  { id: "city", label: "City" },
  { id: "state", label: "State" },
  { id: "country", label: "Country" },
  { id: "postal_code", label: "Postal Code" },
  { id: "complete_address", label: "Complete Address" },
  { id: "latitude", label: "Latitude" },
  { id: "longitude", label: "Longitude" },
];

export const brandTableColumns = [
  { id: "details", label: "Details", maxWidth: "50px" }, // Added for the expand/collapse icon
  { id: "name", label: "Brands", maxWidth: "130px" },
  {
    id: "market",
    label: "Location",
    maxWidth: "140px",
    align: "center",
  },
  // {
  //   id: "preferred_market",
  //   label: "Preferred Market",
  //   maxWidth: "160px",
  //   align: "center",
  // },
  {
    id: "product_category",
    label: "Product Category",
    maxWidth: "160px",
    align: "center",
  },
  {
    id: "target_group",
    label: "Target Group",
    maxWidth: "160px",
    align: "center",
  },
  { id: "style", label: "Product Style", maxWidth: "160px", align: "center" },
  { id: "age", label: "Age group", maxWidth: "160px", align: "center" },
  { id: "price", label: "Price Range", maxWidth: "160px", align: "center" },
  { id: "is_program", label: "In Program", maxWidth: "50px", align: "center" },
  {
    id: "add_to_program",
    label: "Actions",
    align: "center",
    maxWidth: "150px",
  },
  {
    id: "edit",
    label: "Options",
  },
];

export const showroomsTableColumns = [
  { id: "details", label: "Details", maxWidth: "50px" }, // Added for the expand/collapse icon
  { id: "name", label: "Showrooms", maxWidth: "140px" },
  { id: "agents", label: "Agents", align: "center", maxWidth: "160px" },
  {
    id: "market",
    label: "Location",
    maxWidth: "140px",
    align: "center",
  },
  // {
  //   id: "preferred_market",
  //   label: "Preferred Market",
  //   maxWidth: "160px",
  //   align: "center",
  // },
  {
    id: "product_category",
    label: "Product Category",
    maxWidth: "160px",
    align: "center",
  },
  {
    id: "target_group",
    label: "Target Group",
    maxWidth: "160px",
    align: "center",
  },
  { id: "style", label: "Product Style", maxWidth: "160px", align: "center" },
  { id: "age", label: "Age group", maxWidth: "160px", align: "center" },
  { id: "price", label: "Price Range", maxWidth: "160px", align: "center" },
  {
    id: "edit",
    label: "Options",
  },
];
export const wholesale_group = [
  {
    label: "distributor",
    id: 1,
    image: DistributorImg,
    imageBlack: DistributorBlackImg,
  },
  {
    label: "agency",
    id: 2,
    image: DistributorImg,
    imageBlack: DistributorBlackImg,
  },
];

export const activites = [
  { label: "Boutique" },
  { label: "Retail chain" },
  { label: "Department store" },
  { label: "Online store" },
  { label: "Perfumery" },
];

export const market = [
  { label: "Open", id: 0, code: "OP" },
  { label: "afghanistan", id: 1, code: "AF" },
  { label: "albania", id: 2, code: "AL" },
  { label: "algeria", id: 3, code: "DZ" },
  { label: "andorra", id: 4, code: "AD" },
  { label: "angola", id: 5, code: "AO" },
  { label: "austria", id: 33934, code: "AT" },
  { label: "antigua and barbuda", id: 6, code: "AG" },
  { label: "argentina", id: 7, code: "AR" },
  { label: "armenia", id: 8, code: "AM" },
  { label: "australia", id: 9, code: "AU" },
  { label: "azerbaijan", id: 10, code: "AZ" },
  { label: "bahrain", id: 11, code: "BH" },
  { label: "bangladesh", id: 12, code: "BD" },
  { label: "barbados", id: 13, code: "BB" },
  { label: "belarus", id: 14, code: "BY" },
  { label: "belgium", id: 15, code: "BE" },
  { label: "belize", id: 16, code: "BZ" },
  { label: "benin", id: 17, code: "BJ" },
  { label: "bhutan", id: 18, code: "BT" },
  { label: "bolivia", id: 19, code: "BO" },
  { label: "bosnia and Herzegovina", id: 20, code: "BA" },
  { label: "botswana", id: 21, code: "BW" },
  { label: "brazil", id: 22, code: "BR" },
  { label: "brunei", id: 23, code: "BN" },
  { label: "bulgaria", id: 24, code: "BG" },
  { label: "burkina faso", id: 25, code: "BF" },
  { label: "burundi", id: 26, code: "BI" },
  { label: "cabo verde", id: 27, code: "CV" },
  { label: "cambodia", id: 28, code: "KH" },
  { label: "cameroon", id: 29, code: "CM" },
  { label: "canada", id: 30, code: "CA" },
  { label: "central african republic", id: 31, code: "CF" },
  { label: "chad", id: 32, code: "TD" },
  { label: "channel islands", id: 33, code: "JE" },
  { label: "chile", id: 34, code: "CL" },
  { label: "china", id: 35, code: "CN" },
  { label: "colombia", id: 36, code: "CO" },
  { label: "comoros", id: 37, code: "KM" },
  { label: "congo", id: 38, code: "CG" },
  { label: "costa rica", id: 39, code: "CR" },
  { label: "côte d'Ivoire", id: 40, code: "CI" },
  { label: "croatia", id: 41, code: "HR" },
  { label: "cuba", id: 42, code: "CU" },
  { label: "cyprus", id: 43, code: "CY" },
  { label: "czech republic", id: 44, code: "CZ" },
  { label: "denmark", id: 45, code: "DK" },
  { label: "djibouti", id: 46, code: "DJ" },
  { label: "dominica", id: 47, code: "DM" },
  { label: "dominican republic", id: 48, code: "DO" },
  { label: "dR congo", id: 49, code: "CD" },
  { label: "ecuador", id: 50, code: "EC" },
  { label: "egypt", id: 51, code: "EG" },
  { label: "el salvador", id: 52, code: "SV" },
  { label: "equatorial guinea", id: 53, code: "GQ" },
  { label: "eritrea", id: 54, code: "ER" },
  { label: "estonia", id: 55, code: "EE" },
  { label: "eswatini", id: 56, code: "SZ" },
  { label: "ethiopia", id: 57, code: "ET" },
  { label: "faeroe islands", id: 58, code: "FO" },
  { label: "finland", id: 59, code: "FI" },
  { label: "france", id: 60, code: "FR" },
  { label: "french guiana", id: 61, code: "GF" },
  { label: "gabon", id: 62, code: "GA" },
  { label: "gambia", id: 63, code: "GM" },
  { label: "georgia", id: 64, code: "GE" },
  { label: "germany", id: 65, code: "DE" },
  { label: "ghana", id: 66, code: "GH" },
  { label: "gibraltar", id: 67, code: "GI" },
  { label: "greece", id: 68, code: "GR" },
  { label: "grenada", id: 69, code: "GD" },
  { label: "guatemala", id: 70, code: "GT" },
  { label: "guinea", id: 71, code: "GN" },
  { label: "guinea-Bissau", id: 72, code: "GW" },
  { label: "guyana", id: 73, code: "GY" },
  { label: "haiti", id: 74, code: "HT" },
  { label: "holy see", id: 75, code: "VA" },
  { label: "honduras", id: 76, code: "HN" },
  { label: "hong kong", id: 77, code: "HK" },
  { label: "hungary", id: 78, code: "HU" },
  { label: "iceland", id: 79, code: "IS" },
  { label: "india", id: 80, code: "IN" },
  { label: "indonesia", id: 81, code: "ID" },
  { label: "iran", id: 82, code: "IR" },
  { label: "iraq", id: 83, code: "IQ" },
  { label: "ireland", id: 84, code: "IE" },
  { label: "isle of Man", id: 85, code: "IM" },
  { label: "israel", id: 86, code: "IL" },
  { label: "italy", id: 87, code: "IT" },
  { label: "jamaica", id: 88, code: "JM" },
  { label: "japan", id: 89, code: "JP" },
  { label: "jordan", id: 90, code: "JO" },
  { label: "kazakhstan", id: 91, code: "KZ" },
  { label: "kenya", id: 92, code: "KE" },
  { label: "kuwait", id: 93, code: "KW" },
  { label: "kyrgyzstan", id: 94, code: "KG" },
  { label: "laos", id: 95, code: "LA" },
  { label: "latvia", id: 96, code: "LV" },
  { label: "lebanon", id: 97, code: "LB" },
  { label: "lesotho", id: 98, code: "LS" },
  { label: "liberia", id: 99, code: "LR" },
  { label: "libya", id: 100, code: "LY" },
  { label: "liechtenstein", id: 101, code: "LI" },
  { label: "lithuania", id: 102, code: "LT" },
  { label: "luxembourg", id: 103, code: "LU" },
  { label: "macao", id: 104, code: "MO" },
  { label: "madagascar", id: 105, code: "MG" },
  { label: "malawi", id: 106, code: "MW" },
  { label: "malaysia", id: 107, code: "MY" },
  { label: "maldives", id: 108, code: "MV" },
  { label: "mali", id: 109, code: "ML" },
  { label: "malta", id: 110, code: "MT" },
  { label: "mauritania", id: 111, code: "MR" },
  { label: "mauritius", id: 112, code: "MU" },
  { label: "mayotte", id: 113, code: "YT" },
  { label: "mexico", id: 114, code: "MX" },
  { label: "moldova", id: 115, code: "MD" },
  { label: "monaco", id: 116, code: "MC" },
  { label: "mongolia", id: 117, code: "MN" },
  { label: "montenegro", id: 118, code: "ME" },
  { label: "morocco", id: 119, code: "MA" },
  { label: "mozambique", id: 120, code: "MZ" },
  { label: "myanmar", id: 121, code: "MM" },
  { label: "namibia", id: 122, code: "NA" },
  { label: "nepal", id: 123, code: "NP" },
  { label: "new zealand", id: 194, code: "NZ" },
  { label: "netherlands", id: 124, code: "NL" },
  { label: "nicaragua", id: 125, code: "NI" },
  { label: "niger", id: 126, code: "NE" },
  { label: "nigeria", id: 127, code: "NG" },
  { label: "north Korea", id: 128, code: "KP" },
  { label: "north Macedonia", id: 129, code: "MK" },
  { label: "norway", id: 130, code: "NO" },
  { label: "oman", id: 131, code: "OM" },
  { label: "pakistan", id: 132, code: "PK" },
  { label: "panama", id: 133, code: "PA" },
  { label: "paraguay", id: 134, code: "PY" },
  { label: "peru", id: 135, code: "PE" },
  { label: "philippines", id: 136, code: "PH" },
  { label: "poland", id: 137, code: "PL" },
  { label: "portugal", id: 138, code: "PT" },
  { label: "qatar", id: 139, code: "QA" },
  { label: "réunion", id: 140, code: "RE" },
  { label: "romania", id: 141, code: "RO" },
  { label: "russia", id: 142, code: "RU" },
  { label: "rwanda", id: 143, code: "RW" },
  { label: "saint Helena", id: 144, code: "SH" },
  { label: "saint Kitts and Nevis", id: 145, code: "KN" },
  { label: "saint Lucia", id: 146, code: "LC" },
  { label: "saint Vincent and the Grenadines", id: 147, code: "VC" },
  { label: "san marino", id: 148, code: "SM" },
  { label: "sao Tome & Principe", id: 149, code: "ST" },
  { label: "saudi arabia", id: 150, code: "SA" },
  { label: "senegal", id: 151, code: "SN" },
  { label: "serbia", id: 152, code: "RS" },
  { label: "seychelles", id: 153, code: "SC" },
  { label: "sierra leone", id: 154, code: "SL" },
  { label: "singapore", id: 155, code: "SG" },
  { label: "slovakia", id: 156, code: "SK" },
  { label: "slovenia", id: 157, code: "SI" },
  { label: "somalia", id: 158, code: "SO" },
  { label: "south africa", id: 159, code: "ZA" },
  { label: "south korea", id: 160, code: "KR" },
  { label: "south sudan", id: 161, code: "SS" },
  { label: "spain", id: 162, code: "ES" },
  { label: "sri lanka", id: 163, code: "LK" },
  { label: "state of palestine", id: 164, code: "PS" },
  { label: "sudan", id: 165, code: "SD" },
  { label: "suriname", id: 166, code: "SR" },
  { label: "sweden", id: 167, code: "SE" },
  { label: "switzerland", id: 168, code: "CH" },
  { label: "syria", id: 169, code: "SY" },
  { label: "taiwan", id: 170, code: "TW" },
  { label: "tajikistan", id: 171, code: "TJ" },
  { label: "tanzania", id: 172, code: "TZ" },
  { label: "thailand", id: 173, code: "TH" },
  { label: "the Bahamas", id: 174, code: "BS" },
  { label: "timor-Leste", id: 175, code: "TL" },
  { label: "togo", id: 176, code: "TG" },
  { label: "trinidad and tobago", id: 177, code: "TT" },
  { label: "tunisia", id: 178, code: "TN" },
  { label: "turkey", id: 179, code: "TR" },
  { label: "turkmenistan", id: 180, code: "TM" },
  { label: "uganda", id: 181, code: "UG" },
  { label: "ukraine", id: 182, code: "UA" },
  { label: "united arab emirates", id: 183, code: "AE" },
  { label: "united kingdom", id: 184, code: "GB" },
  { label: "united states", id: 185, code: "US" },
  { label: "uruguay", id: 186, code: "UY" },
  { label: "uzbekistan", id: 187, code: "UZ" },
  { label: "venezuela", id: 188, code: "VE" },
  { label: "vietnam", id: 189, code: "VN" },
  { label: "western sahara", id: 190, code: "EH" },
  { label: "yemen", id: 191, code: "YE" },
  { label: "zambia", id: 192, code: "ZM" },
  { label: "zimbabwe", id: 193, code: "ZW" },
];

export const target_group = [
  {
    label: "Men",
    id: 1,
    imageBlack: MenImgBlack,
    imageWhite: MenImgWhite,
  },
  {
    label: "Women",
    id: 2,
    imageBlack: WomenImgBlack,
    imageWhite: WomenImgWhite,
  },
  {
    label: "Kids",
    id: 3,
    imageBlack: KidsImgBlack,
    imageWhite: KidsImgWhite,
  },
];

export const age = [
  {
    label: "0-1 Baby",
    id: 1,
    imageBlack: BabyImgBlack,
    imageWhite: BabyImgWhite,
    imageWomenBlack: BabyImgBlack,
    imageWomenWhite: BabyImgWhite,
  },
  {
    label: "2-3 Toddler",
    id: 2,
    imageBlack: ToddlerImgBlack,
    imageWhite: ToddlerImgWhite,
    imageWomenBlack: ToddlerImgBlack,
    imageWomenWhite: ToddlerImgWhite,
  },
  {
    label: "4-11 Kid",
    id: 3,
    imageBlack: KidImgBlack,
    imageWhite: KidImgWhite,
    imageWomenBlack: KidImgBlack,
    imageWomenWhite: KidImgWhite,
  },
  {
    label: "12-18 Teen",
    id: 4,
    imageBlack: TeenImgBlack,
    imageWhite: TeenImgWhite,
    imageWomenBlack: TeenImg2Black,
    imageWomenWhite: TeenImg2White,
    imageBothBlack: TeenImgBothBlack,
    imageBothWhite: TeenImgBothWhite,
  },
  {
    label: "19-30 Young adult",
    id: 5,
    imageBlack: YoungImgBlack,
    imageWhite: YoungImgWhite,
    imageWomenBlack: YoungImg2Black,
    imageWomenWhite: YoungImg2White,
    imageBothBlack: YoungImgBothBlack,
    imageBothWhite: YoungImgBothWhite,
  },
  {
    label: "31-45 Middle aged",
    id: 6,
    imageBlack: MiddleImgBlack,
    imageWhite: MiddleImgWhite,
    imageWomenBlack: MiddleImg2Black,
    imageWomenWhite: MiddleImg2White,
    imageBothBlack: MiddleImgBothBlack,
    imageBothWhite: MiddleImgBothWhite,
  },
  {
    label: "46-55 Adult",
    id: 7,
    imageBlack: SeniorImgBlack,
    imageWhite: SeniorImgWhite,
    imageWomenBlack: YoungImg2Black,
    imageWomenWhite: YoungImg2White,
    imageBothBlack: MiddleImgBothBlack,
    imageBothWhite: MiddleImgBothWhite,
  },
  {
    id: 8,
    label: "56+ Senior",
    imageBlack: SeniorImgBlack,
    imageWhite: SeniorImgWhite,
    imageWomenBlack: SeniorImgBlack,
    imageWomenWhite: SeniorImgWhite,
    imageBothBlack: SeniorImgBothBlack,
    imageBothWhite: SeniorImgBothWhite,
  },
  {
    id: 9,
    label: "All ages",
    imageBlack: AllAgesBlack,
    imageWhite: AllAgesWhite,
  },
];

export const style = [
  {
    label: "Sportive",
    id: 1,
    imageBlack: Sport1ImgBlack,
    imageWhite: Sport1ImgWhite,
    imageWomenBlack: Sport2ImgBlack,
    imageWomenWhite: Sport2ImgWhite,
    imageKidsBlack: Sport3ImgBlack,
    imageKidsWhite: Sport3ImgWhite,
    // imageBothBlack: TeenImgBothBlack,
    // imageBothWhite: TeenImgBothWhite,
  },
  {
    label: "Casual",
    id: 2,
    imageBlack: Casual1ImgBlack,
    imageWhite: Casual1ImgWhite,
    imageWomenBlack: Casual2ImgBlack,
    imageWomenWhite: Casual2ImgWhite,
    imageKidsBlack: Casual3ImgBlack,
    imageKidsWhite: Casual3ImgWhite,
  },
  {
    label: "Contemporary",
    id: 3,
    imageBlack: Contemporary1ImgBlack,
    imageWhite: Contemporary1ImgWhite,
    imageWomenBlack: Contemporary2ImgBlack,
    imageWomenWhite: Contemporary2ImgWhite,
    imageKidsBlack: Contemporary3ImgBlack,
    imageKidsWhite: Contemporary3ImgWhite,
  },
  {
    label: "Bohemian",
    id: 4,
    imageBlack: Bohemian1ImgBlack,
    imageWhite: Bohemian1ImgWhite,
    imageWomenBlack: Bohemian2ImgBlack,
    imageWomenWhite: Bohemian2ImgWhite,
    imageKidsBlack: Bohemian3ImgBlack,
    imageKidsWhite: Bohemian3ImgWhite,
  },
  {
    label: "Classic",
    id: 5,
    imageBlack: Classic1ImgBlack,
    imageWhite: Classic1ImgWhite,
    imageWomenBlack: Classic2ImgBlack,
    imageWomenWhite: Classic2ImgWhite,
    imageKidsBlack: Classic3ImgBlack,
    imageKidsWhite: Classic3ImgWhite,
  },
  {
    label: "Athleisure",
    id: 6,
    imageBlack: Athleisure1ImgBlack,
    imageWhite: Athleisure1ImgWhite,
    imageWomenBlack: Athleisure2ImgBlack,
    imageWomenWhite: Athleisure2ImgWhite,
    imageKidsBlack: Athleisure3ImgBlack,
    imageKidsWhite: Athleisure3ImgWhite,
  },
];

export const product_category = [
  {
    label: "Apparel",
    id: 1,
    imageBlack: Apparel2ImgBlack,
    imageWhite: Apparel2ImgWhite,
  },
  {
    label: "Footwear",
    id: 2,
    imageBlack: FootWear2ImgBlack,
    imageWhite: FootWear2ImgWhite,
  },
  {
    label: "Outerwear",
    id: 3,
    imageBlack: OuterWear1ImgBlack,
    imageWhite: OuterWear1ImgWhite,
  },
  {
    label: "Jewelry",
    id: 4,
    imageBlack: Jewelry1ImgBlack,
    imageWhite: Jewelry1ImgWhite,
  },
  {
    label: "Bags",
    id: 5,
    imageBlack: Bags1ImgBlack,
    imageWhite: Bags1ImgWhite,
  },
  {
    label: "Lingerie",
    id: 6,
    imageBlack: Lingerie1ImgBlack,
    imageWhite: Lingerie1ImgWhite,
  },
  {
    label: "Swimwear",
    id: 7,
    imageBlack: Swimwear1ImgBlack,
    imageWhite: Swimwear1ImgWhite,
  },
  {
    label: "Watches",
    id: 8,
    imageBlack: Accessories1ImgBlack,
    imageWhite: Accessories1ImgWhite,
  },
  {
    label: "Eyewear",
    id: 9,
    imageBlack: Glases1ImgBlack,
    imageWhite: Glases1ImgWhite,
  },
  {
    label: "Accessories",
    id: 10,
    imageBlack: Accessories2ImgBlack,
    imageWhite: Accessories2ImgWhite,
  },
  {
    label: "Socks",
    id: 11,
    imageBlack: Socks1ImgBlack,
    imageWhite: Socks1ImgWhite,
  },
  {
    label: "Occasionwear",
    id: 12,
    imageBlack: Occasion1ImgBlack,
    imageWhite: Occasion1ImgWhite,
  },
];

export const price = [
  {
    label: 'Apparel Low 0-49€',
    id: 1,
    smallLable: '0-49€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Apparel Mid 50-249€',
    id: 2,
    smallLable: '50-249€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Apparel High 250-749€',
    id: 3,
    smallLable: '250-749€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Apparel Premium 750€+',
    id: 4,
    smallLable: '750€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Footwear Low 0-99€',
    id: 5,
    smallLable: '0-99€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Footwear Mid 100-249€',
    id: 6,
    smallLable: '100-249€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Footwear High 250-499€',
    id: 7,
    smallLable: '250-499€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Footwear Premium 500€+',
    id: 8,
    smallLable: '500€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Outerwear Low 0-149€',
    id: 9,
    smallLable: '0-149€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Outerwear Mid 100-349€',
    id: 10,
    smallLable: '100-349€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Outerwear High 350-999€',
    id: 11,
    smallLable: '350-999€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Outerwear Premium 1000€+',
    id: 12,
    smallLable: '1000€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Accessories Low 0-49€',
    id: 13,
    smallLable: '0-49€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Accessories Mid 50-149€',
    id: 14,
    smallLable: '50-149€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Accessories High 150-249€',
    id: 15,
    smallLable: '150-249€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Accessories Premium 250€+',
    id: 16,
    smallLable: '250€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Jewelry Low 0-74€',
    id: 17,
    smallLable: '0-74€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Jewelry Mid 75-249€',
    id: 18,
    smallLable: '75-249€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Jewelry High 250-499€',
    id: 19,
    smallLable: '250-499€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Jewelry Premium 500€+',
    id: 20,
    smallLable: '500€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Bags Low 0-99€',
    id: 21,
    smallLable: '0-99€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Bags Mid 100-449€',
    id: 22,
    smallLable: '100-449€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Bags High 450-999€',
    id: 23,
    smallLable: '450-999€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Bags Premium 1000€+',
    id: 24,
    smallLable: '1000€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Lingerie Low 0-24€',
    id: 25,
    smallLable: '0-24€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Lingerie Mid 25-49€',
    id: 26,
    smallLable: '25-49€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Lingerie High 50-149€',
    id: 27,
    smallLable: '50-149€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Lingerie Premium 150€+',
    id: 28,
    smallLable: '150€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Swimwear Low 0-74€',
    id: 29,
    smallLable: '0-74€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Swimwear Mid 75-199€',
    id: 30,
    smallLable: '75-199€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Swimwear High 200-349€',
    id: 31,
    smallLable: '200-349€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Swimwear Premium 250+',
    id: 32,
    smallLable: '350€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Swimwear Premium 350€+',
    id: 32,
    smallLable: '350€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Watches Low 0-99€',
    id: 33,
    smallLable: '0-99€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Watches Mid 100-249€',
    id: 34,
    smallLable: '100-249€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Watches High 250-999€',
    id: 35,
    smallLable: '250-999€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Watches Premium 1000€+',
    id: 36,
    smallLable: '1000€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Eyewear Low 0-74€',
    id: 37,
    smallLable: '0-74€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Eyewear Mid 75-199€',
    id: 38,
    smallLable: '75-199€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Eyewear High 200-649€',
    id: 39,
    smallLable: '200-649€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Eyewear Premium 650€+',
    id: 40,
    smallLable: '650€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Socks Low 0-10€',
    id: 41,
    smallLable: '0-10€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Socks Mid 10-15€',
    id: 42,
    smallLable: '10-15€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Socks High 15-45€',
    id: 43,
    smallLable: '15-45€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Socks Premium 45€+',
    id: 44,
    smallLable: '45€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },

  {
    label: 'Occasionwear Low 0-149€',
    id: 45,
    smallLable: '0-149€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Occasionwear Mid 150-349€',
    id: 46,
    smallLable: '150-349€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Occasionwear High 350-999€',
    id: 47,
    smallLable: '350-999€',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Occasionwear Premium 1000€+',
    id: 48,
    smallLable: '1000€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },
  {
    label: 'Jewellery Premium 1000€+',
    id: 48,
    smallLable: '2000€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },

  {
    label: 'Jewellery Low 0-149€+',
    id: 49,
    smallLable: '0-149€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },

  {
    label: 'Jewellery Mid 150-349+',
    id: 50,
    smallLable: '2000€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  },

  {
    label: 'Jewellery High 350-999€+',
    id: 51,
    smallLable: '350-999€+',
    image: PriceImg,
    imageBlack: PriceBlackImg
  }
]

export const scrappedIcons = [
  {
    img: "/scrapp.png",
    name: "All Scrapped Data",
    icon: "scrapp.png",
    label: "predictions",
  },
  {
    img: "/websiteScrapp.png",
    name: "Website",
    label: "website",
    icon: "/websiteScrapp.png",
  },
  {
    img: "/instascrapp.png",
    name: "Instagram",
    label: "instagram",
    icon: "/instascrapp.png",
  },
  {
    img: "/linkedInScrapp.png",
    name: "LinkedIn",
    label: "linkedin",
    icon: "/linkedInScrapp.png",
  },

  {
    img: "/fbscrapp.png",
    name: "Facebook",
    label: "facebook",
    icon: "/fbscrapp.png",
  },
];

export const columns = [
  {
    title: "Age Group",
    field: "age",
  },
  {
    title: "Product Style",
    field: "style",
  },
  {
    title: "Category",
    field: "product_category",
  },
  {
    title: "Target Group",
    field: "target_group",
  },
  // {
  //   title: "Preferred Market",
  //   field: "preferred_market",
  // },
  {
    title: "Location",
    field: "market",
  },
  {
    title: "Price Range",
    field: "price",
  },
  {
    title: "Eco Friendly",
    field: "eco_friendly",
  },
  {
    title: "Size",
    field: "size",
  },
  {
    title: "Brand Rating",
    field: "brandRating",
  },
  {
    title: "Brand Awareness",
    field: "brandAwareness",
  },
  {
    title: "Ecom Rating",
    field: "ecomRating",
  },
  {
    title: "POS Rating",
    field: "posRating",
  },
  {
    title: "Market Diversity",
    field: "marketDiversity",
  },
  {
    title: "Retailer Awareness",
    field: "retailerAwareness",
  },
];

export const territories = [
  {
    label: "South East Asia",
    id: 4332,
    markets: [
      "Brunei Darussalam",
      "Cambodia",
      "Indonesia",
      "Lao People's",
      "Democratic Republic",
      "Malaysia",
      "Myanmar",
      "Philippines",
      "Singapore",
      "Thailand",
      "Timor-Leste",
      "Vietnam",
    ],
  },
  {
    label: "Benelux",
    id: 4333,
    markets: ["Belgium", "Netherlands", "Luxembourg"],
  },
  {
    label: "Scandinavia",
    id: 3424,
    markets: ["Denmark", "Sweden", "Norway", "Finland", "Iceland"],
  },
  { label: "Dach", id: 4894, markets: ["Germany, Austria"] },
  {
    label: "Middle-East",
    id: 1321,
    markets: [
      "Turkey",
      "Cyprus",
      "Lebanon",
      "Syria",
      "Iraq",
      "Iran",
      "Israel",
      "Jordan",
      "Saudi Arabia",
      "Kuwait",
      "Qatar",
      "Bahrain",
      "United Arab Emirates",
      "Oman",
      "Yemen",
    ],
  },
  {
    label: "Eastern Europe",
    id: 2649,
    markets: [
      "Russia",
      "Ukraine",
      "Poland",
      "Romania",
      "Czech Republic",
      "Hungary",
      "Belarus",
      "Bulgaria",
      "Slovakia",
      "Moldova",
    ],
  },
  {
    label: "Western Europe",
    id: 4946,
    markets: [
      "Germany",
      "France",
      "Netherlands",
      "Belgium",
      "Austria",
      "Switzerland",
      "Luxembourg",
      "Monaco",
      "Liechtenstein",
    ],
  },
  {
    label: "Europe",
    id: 8799,
    markets: [
      "Germany",
      "France",
      "Czech Republic",
      "Austria",
      "Sweden",
      "Italy",
      "Spain",
      "Poland",
      "Hungary",
      "Denmark",
      "Finland",
      "Russia",
      "Romania",
      "Norway",
      "Turkey",
      "Ireland",
      "Cyprus",
      "Greece",
      "Belgium",
      "Netherlands",
      "Luxembourg",
      "United Kingdom",
    ],
  },
  ...market.filter((m) => m?.label !== "Open"),
];

export const eco_friendly = [
  {
    id: 1,
    label: "Eco Friendly",
    imageBlack: EcoFriendly,
    imageWhite: EcoFriendly,
  },
  {
    id: 2,
    label: "Not Eco Friendly",
    imageBlack: NonEcoFriendly,
    imageWhite: NonEcoFriendly,
  },
];

export const createBrandRating = (ratingValue) => {
  if (!ratingValue) return [];

  return [
    {
      id: 1,
      label: `Rating: ${Math.ceil(ratingValue).toFixed()}`,
      imageBlack: RatingBlackImg,
      imageWhite: RatingImg,
      value: ratingValue.toString(),
    },
  ];
};

export const brand_rating_options = [
  {
    id: 0,
    value: "0",
    label: "Rating: 0",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
  {
    id: 1,
    value: "1",
    label: "Rating: 1",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
  {
    id: 2,
    value: "2",
    label: "Rating: 2",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
  {
    id: 3,
    value: "3",
    label: "Rating: 3",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
  {
    id: 4,
    value: "4",
    label: "Rating: 4",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
  {
    id: 5,
    value: "5",
    label: "Rating: 5",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
  {
    id: 6,
    value: "6",
    label: "Rating: 6",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
  {
    id: 7,
    value: "7",
    label: "Rating: 7",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
  {
    id: 8,
    value: "8",
    label: "Rating: 8",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
  {
    id: 9,
    value: "9",
    label: "Rating: 9",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
  {
    id: 10,
    value: "10",
    label: "Rating: 10",
    imageBlack: RatingBlackImg,
    imageWhite: RatingImg,
  },
];

export const brand_awareness_options = [
  {
    id: 0,
    value: "0",
    label: "Rating: 0",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 1,
    value: "1",
    label: "Rating: 1",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 2,
    value: "2",
    label: "Rating: 2",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 3,
    value: "3",
    label: "Rating: 3",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 4,
    value: "4",
    label: "Rating: 4",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 5,
    value: "5",
    label: "Rating: 5",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 6,
    value: "6",
    label: "Rating: 6",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 7,
    value: "7",
    label: "Rating: 7",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 8,
    value: "8",
    label: "Rating: 8",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 9,
    value: "9",
    label: "Rating: 9",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 10,
    value: "10",
    label: "Rating: 10",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
];

export const retailer_awareness_options = [
  {
    id: 0,
    value: "0",
    label: "Rating: 0",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 1,
    value: "1",
    label: "Rating: 1",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 2,
    value: "2",
    label: "Rating: 2",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 3,
    value: "3",
    label: "Rating: 3",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 4,
    value: "4",
    label: "Rating: 4",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 5,
    value: "5",
    label: "Rating: 5",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 6,
    value: "6",
    label: "Rating: 6",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 7,
    value: "7",
    label: "Rating: 7",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 8,
    value: "8",
    label: "Rating: 8",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 9,
    value: "9",
    label: "Rating: 9",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
  {
    id: 10,
    value: "10",
    label: "Rating: 10",
    imageBlack: Awareness,
    imageWhite: Awareness,
  },
];

// Ecom Rating options (1-10)
export const ecom_rating_options = [
  {
    id: 0,
    value: "0",
    label: "Rating: 0",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
  {
    id: 1,
    value: "1",
    label: "Rating: 1",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
  {
    id: 2,
    value: "2",
    label: "Rating: 2",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
  {
    id: 3,
    value: "3",
    label: "Rating: 3",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
  {
    id: 4,
    value: "4",
    label: "Rating: 4",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
  {
    id: 5,
    value: "5",
    label: "Rating: 5",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
  {
    id: 6,
    value: "6",
    label: "Rating: 6",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
  {
    id: 7,
    value: "7",
    label: "Rating: 7",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
  {
    id: 8,
    value: "8",
    label: "Rating: 8",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
  {
    id: 9,
    value: "9",
    label: "Rating: 9",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
  {
    id: 10,
    value: "10",
    label: "Rating: 10",
    imageBlack: EcomImg,
    imageWhite: EcomImg,
  },
];

// POS Rating options (1-10)
export const pos_rating_options = [
  {
    id: 0,
    value: "0",
    label: "Rating: 0",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
  {
    id: 1,
    value: "1",
    label: "Rating: 1",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
  {
    id: 2,
    value: "2",
    label: "Rating: 2",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
  {
    id: 3,
    value: "3",
    label: "Rating: 3",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
  {
    id: 4,
    value: "4",
    label: "Rating: 4",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
  {
    id: 5,
    value: "5",
    label: "Rating: 5",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
  {
    id: 6,
    value: "6",
    label: "Rating: 6",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
  {
    id: 7,
    value: "7",
    label: "Rating: 7",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
  {
    id: 8,
    value: "8",
    label: "Rating: 8",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
  {
    id: 9,
    value: "9",
    label: "Rating: 9",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
  {
    id: 10,
    value: "10",
    label: "Rating: 10",
    imageBlack: PosImg,
    imageWhite: PosImg,
  },
];

// Market Diversity options (1-10)
export const market_diversity_options = [
  {
    id: 0,
    value: "0",
    label: "Rating: 0",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
  {
    id: 1,
    value: "1",
    label: "Rating: 1",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
  {
    id: 2,
    value: "2",
    label: "Rating: 2",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
  {
    id: 3,
    value: "3",
    label: "Rating: 3",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
  {
    id: 4,
    value: "4",
    label: "Rating: 4",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
  {
    id: 5,
    value: "5",
    label: "Rating: 5",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
  {
    id: 6,
    value: "6",
    label: "Rating: 6",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
  {
    id: 7,
    value: "7",
    label: "Rating: 7",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
  {
    id: 8,
    value: "8",
    label: "Rating: 8",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
  {
    id: 9,
    value: "9",
    label: "Rating: 9",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
  {
    id: 10,
    value: "10",
    label: "Rating: 10",
    imageBlack: MarketImg,
    imageWhite: MarketImg,
  },
];

export const price_point = [
  {
    id: 1,
    label: 'Luxury',
    value: 'Premium'
  },
  {
    id: 2,
    label: 'Premium',
    value: 'High'
  },
  {
    id: 3,
    label: 'Mid-range',
    value: 'Mid'
  },
  {
    id: 4,
    label: 'Affordable',
    value: 'Low'
  }
]

export const size = [
  {
    id: 1,
    label: "Standard",
    imageBlack: SizeStandard,
    imageWhite: SizeStandard,
  },
  { id: 2, label: "Big", imageBlack: SizeBig, imageWhite: SizeBig },
];

export const getDropdownOptions = (columnId, onlyLabel) => {
  switch (columnId) {
    case "wholesale_group":
      return wholesale_group.map((option) =>
        onlyLabel ? option.label : option
      );

    case "target_group":
      return target_group.map((option) => (onlyLabel ? option.label : option));

    case "age":
      return age
        ?.filter((a) => a?.label !== "All ages")
        .map((option) => (onlyLabel ? option.label : option));

    case "style":
      return style.map((option) => (onlyLabel ? option.label : option));

    case "product_category":
      return product_category.map((option) =>
        onlyLabel ? option.label : option
      );

    case "price":
      return price.map((option) => (onlyLabel ? option.label : option));

    case "price_point":
      return price_point.map((option) => (onlyLabel ? option.label : option));

    case "market":
      return market.map((option) => (onlyLabel ? option.label : option));
    case "preferred_market":
      return market.map((option) => (onlyLabel ? option.label : option));
    case "market_of_interest":
      return market.map((option) => (onlyLabel ? option.label : option));
    case "eco_friendly":
      return eco_friendly.map((option) => (onlyLabel ? option.label : option));
    case "size":
      return size.map((option) => (onlyLabel ? option.label : option));

    case "brandRating":
      return brand_rating_options?.map((option) =>
        onlyLabel ? option.label : option
      );


    case "brandRatingUpgrade":
      return brand_rating_options?.map((option) =>
        onlyLabel ? option.label : option
      );

    case "brandAwareness":
      return brand_awareness_options?.map((option) =>
        onlyLabel ? option.label : option
      );

    case "retailerAwareness":
      return retailer_awareness_options?.map((option) =>
        onlyLabel ? option.label : option
      );

    case "ecomRating":
      return ecom_rating_options?.map((option) =>
        onlyLabel ? option.label : option
      );

    case "posRating":
      return pos_rating_options?.map((option) =>
        onlyLabel ? option.label : option
      );

    case "marketDiversity":
      return market_diversity_options?.map((option) =>
        onlyLabel ? option.label : option
      );

    // Add more cases for other columns as needed
    default:
      return [];
  }
};

export const populateArray = (unpopulatedArr, populatedArr) => {
  if (unpopulatedArr?.length <= 0) {
    return [];
  }
  return unpopulatedArr?.map((item) => {
    const data =
      populatedArr?.find((pItem) => {
        if (item === 'Not Eco Friendly') {
          return item.toLowerCase() === pItem.label.toLowerCase();
        }
        return item?.includes("Women")
          ? pItem?.label === "Women"
          : item.toLowerCase().includes(pItem.label.toLowerCase());
      }) || {};

    return { ...data, label: item };
  });
};

export const populateArray2 = (values, sourceArray, matchBy = "label") => {
  if (!values || !sourceArray) return [];

  return values
    .map((value) => {
      if (!value || value === "") return null;

      const foundItem = sourceArray.find((item) => {
        switch (matchBy) {
          case "value":
            return item.value === value.toString();
          case "label":
            return item.label.toLowerCase() === value.toLowerCase();
          case "id":
            return item.id === parseInt(value);
          default:
            return item.label.toLowerCase() === value.toLowerCase();
        }
      });

      return foundItem || null;
    })
    .filter((item) => item !== null);
};

export const getCamelCaseWord = (word) => {
  if (!word) return ''

  const safeWord = String(word).trim()

  // Replace underscores/dashes with spaces
  const cleaned = safeWord.replace(/[-_]+/g, ' ')

  // Split camelCase into separate words
  const spaced = cleaned.replace(/([a-z])([A-Z])/g, '$1 $2')

  // Capitalize each word
  return spaced
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ')
}

function extractGroupName(label) {
  // Split the label by the first hyphen or space to get the primary group name
  return label.split("-")[0].trim();
}

export function checkGroups(target_group) {
  // Define the required groups
  const required_groups = ["Men", "Women", "Kids"];

  // Extract group names from target_group
  const found_groups = target_group
    .map((obj) => extractGroupName(obj.label))
    .filter((group) => required_groups.includes(group));

  // Check for 'All'
  if (
    found_groups.includes("Men") &&
    found_groups.includes("Women") &&
    found_groups.includes("Kids")
  ) {
    return "All";
  }

  // Check for 'Men/Women'
  if (found_groups.includes("Men") && found_groups.includes("Women")) {
    return "Men/Women";
  }

  // Return what was found
  if (found_groups.includes("Men")) {
    return "Men";
  }

  if (found_groups.includes("Women")) {
    return "Women";
  }

  // If none of the above conditions are met, return 'None'
  return "None";
}


export const comparisonCriteria = {
  "Already Working With": {
    "A+": [
      "The next-to-brand of this current brand lies in the retailer's brand:white_check_mark:",
    ],
    A: [
      "The next-to brand of this current brand lies in the retailer's competitors:white_check_mark:",
    ],
    B: [
      "The next-to brand of this current brand matches with the next-to brand of the retailer's next-to brand:white_check_mark:",
    ],
    C: [
      "This brand's main profile attributes found under the retailer's  profile attributes:white_check_mark:",
    ],
  },
  "Matched By AI": {
    "A+": [
      "The next-to-brand of this current brand lies in the retailer's brand:white_check_mark:",
    ],
    A: [
      "The next-to brand of this current brand lies in the retailer's competitors:white_check_mark:",
    ],
    B: [
      "The next-to brand of this current brand matches with the next-to brand of the retailer's next-to brand:white_check_mark:",
    ],
    C: [
      "This brand's main profile attributes found under the retailer's  profile attributes:white_check_mark:",
    ],
  },
  "Next To Brands": {
    "A+": [
      "Your current brand is eco-friendly:white_check_mark:",
      "Both brands belong to the same main category:white_check_mark:",
      "They offer products in a similar pricing level:white_check_mark:",
    ],
    A: [
      "Your current brand offers big-sized products:white_check_mark:",
      "Both brands belong to the same main category:white_check_mark:",
      "They offer products in a similar pricing level:white_check_mark:",
      "They match the same target group:white_check_mark:",
    ],
    B: [
      "They match the same target group:white_check_mark:",
      "They belong to the same product category:white_check_mark:",
      "They are aligned in pricing:white_check_mark:",
      "They have a fairly similar style:white_check_mark:",
      "They target a similar age group:white_check_mark:",
    ],
    C: [
      "They match the same target group:white_check_mark:",
      "They belong to the same product category:white_check_mark:",
      "Their pricing is somewhat similar:white_check_mark:",
      "They have a similar style:white_check_mark:",
      "They target a similar age group:white_check_mark:",
    ],
    D: [
      "They match the same target group:white_check_mark:",
      "They partly match the product category:white_check_mark:",
      "They are aligned in pricing:white_check_mark:",
      "They have a similar style:white_check_mark:",
      "They target a similar age group:white_check_mark:",
    ],
  },
  Competitors: {
    "A+": [
      "Your current brand is eco-friendly:white_check_mark:",
      "Both brands belong to the same main category:white_check_mark:",
      "They offer products in a similar pricing level:white_check_mark:",
    ],
    A: [
      "Your current brand offers big-sized products:white_check_mark:",
      "Both brands belong to the same main category:white_check_mark:",
      "They offer products in a similar pricing level:white_check_mark:",
      "They match the same target group:white_check_mark:",
    ],
    B: [
      "They match the same target group:white_check_mark:",
      "They belong to the same product category:white_check_mark:",
      "They are aligned in pricing:white_check_mark:",
      "They have a highly similar style:white_check_mark:",
      "They target a similar age group:white_check_mark:",
    ],
  },
};

export function getCriteria(type, label) {
  return comparisonCriteria[type]?.[label] || [];
}
